/** Mapeo ruta → módulo RBAC (backend rbac_catalog). */

export const NAV_RBAC_BY_PATH = {
  '/': 'dashboard',
  '/employee-portal': 'employee_portal',
  '/employees': 'employees',
  '/employee-lifecycle': 'lifecycle',
  '/org-chart': 'org_chart',
  '/records': 'legajo',
  '/attendance': 'attendance',
  '/leaves': 'leaves',
  '/expense-reports': 'expenses',
  '/personal-finance': 'personal_finance',
  '/communications': 'communications',
  '/feed': 'feed',
  '/chat': 'chat',
  '/notifications': 'notifications',
  '/performance': 'evaluations',
  '/training': 'training',
  '/surveys': 'surveys',
  '/awards': 'awards',
  '/people-intelligence': 'people_intelligence',
  '/reports': 'reports',
  '/settings': 'settings',
};

export function rbacModuleForPath(path) {
  return NAV_RBAC_BY_PATH[path] || null;
}
